import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

// ISO R-23, "Legale e privacy": allegati contrattuali da scaricare. Fuori
// dal menu (link in fondo alla colonna, che apre un pannello): la pagina resta
// per i link salvati e per Otello da mobile. Solo amministratori (il server
// lo ricontrolla sui PDF).
const ADMIN_ROLES = ['administrator'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/documents'),
      roles: ADMIN_ROLES,
      component: SettingsContent,
      props: {
        headerTitle: 'SETTINGS_CENTER.LEGAL_PRIVACY',
        icon: 'document',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          name: 'settings_documents_index',
          component: Index,
          roles: ADMIN_ROLES,
        },
      ],
    },
  ],
};
